export const IconButtonTestIdFactory = {
    getIconButtonBase: () => 'icon-button',
    getIconButtonTestId: (testId) => [IconButtonTestIdFactory.getIconButtonBase(), testId].join('-'),
};
